import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "../shape";

export class ShapeStoredData extends Shape {
    width = 200;
    height = 166;

    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 3) / 4 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + (width * 3) / 4 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        let r = height / 30;

        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + (width * 7) / 8, y);
        canv.ctx.lineTo(x + width / 16, y);
        canv.ctx.ellipse(
            x + width / 16,
            y + height / 2,
            width / 16,
            height / 2,
            0,
            (3 / 2) * Math.PI,
            Math.PI / 2,
            true,
        );
        canv.ctx.lineTo(x + (width * 7) / 8, y + height);
        canv.ctx.ellipse(
            x + (width * 7) / 8,
            y + height / 2,
            width / 8,
            height / 2,
            0,
            (1 / 2) * Math.PI,
            (3 / 2) * Math.PI,
        );
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" d="M3.80371 3.25H22.457l-.1054.08789-.0616.00781-.1865.18946-.0879.08984-.1836.16016v.04785c-.022.02789-.0451.05634-.0674.08691v.00098c-.2996.41201-.571 1.01622-.7988 1.7832-.4557 1.53429-.7373 3.7147-.7373 6.2959 0 2.5812.2816 4.7616.7373 6.2959.2278.767.4992 1.3712.7988 1.7832v.001c.0742.1018.147.1882.2188.2617l.001.001.1191.122.1865.1905.0606.0058.1035.0889H3.80371c-.36371 0-.70417-.2303-1.00976-.6504-.30374-.4175-.57635-1.0264-.80469-1.7949C1.53231 16.7665 1.25 14.5828 1.25 12c0-2.58281.28231-4.76651.73926-6.30469.22832-.76853.50093-1.37741.80469-1.79492.30561-.42006.64605-.65038 1.00976-.65039ZM23.084 20.0439c.0676.0355.1276.0821.1816.1348-.0013.0031-.0026.006-.0039.0088l-.1777-.1436Zm.1797-16.22163c-.0522.05068-.11.0952-.1748.12988l.1718-.13867c.0013.00276.0017.00593.003.00879Z"/>
            </svg>
        `;
    }
}
